export default "__VITE_ASSET__D8W9x0Vb__"